import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

import BookForm from '../requests/BookForm'
import CourseForm from '../requests/CourseForm'
import PaperForm from '../requests/PaperForm'
import PolicyForm from '../requests/PolicyForm'
import PodcastForm from '../requests/PodcastForm'
import TerminologyForm from '../requests/TerminologyForm'
import VideoForm from '../requests/VideoForm'
import CodeNotebookForm from '../requests/CodeNotebookForm'

import { RequestStyle } from '../styles'
import { initializeTags } from '../../reducers/tagsReducers'

const RESOURCE_FORMS = [
    { value: 'book', label: 'Book', Form: BookForm },
    { value: 'course', label: 'Course', Form: CourseForm },
    { value: 'paper', label: 'Paper', Form: PaperForm },
    { value: 'policy', label: 'Policy', Form: PolicyForm },
    { value: 'podcast', label: 'Podcast', Form: PodcastForm },
    { value: 'terminology', label: 'Glossary term', Form: TerminologyForm },
    { value: 'video', label: 'Video', Form: VideoForm },
    { value: 'codenotebook', label: 'Code Notebook', Form: CodeNotebookForm },
]

const Request = () => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)

    const [type, setType] = useState('book')

    const SelectedForm = RESOURCE_FORMS.find(f => f.value === type)?.Form

    useEffect(() => {
        if(user) {
            dispatch(initializeTags())
        }
    }, [user, dispatch])

    return (
        <Container {...RequestStyle.container.props} sx={RequestStyle.container.style}>
            <Typography {...RequestStyle.title} gutterBottom>
                Create Resource
            </Typography>
            <Typography {...RequestStyle.paraText} gutterBottom>
                As you are an admin user, please be aware that any resource you create here will be automatically approved and visible to all.
            </Typography>
            <Box>
                <TextField
                    value={type}
                    select
                    helperText={'Select the type of resource you would like to create'}
                    label="Resource Type"
                    onChange={(e)=>setType(e.target.value)}
                    sx={{width: '300px', marginTop: '10px', marginBottom: '10px'}}
                >
                    {RESOURCE_FORMS.map(({ value, label }) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
            <Box>
                {SelectedForm && <SelectedForm user={user} />}
            </Box>
        </Container>
    )
}

export default Request
